import React from "react";
import { Button } from "react-bootstrap";

const fileInputRef = React.createRef();

export default function FileInput(props) {
  const fileReader = new FileReader();
  fileReader.onloadend = handleFileRead;

  function handleFileChosen(file) {
    if (file) fileReader.readAsText(file);
  }

  function handleFileRead(e) {
    const content = fileReader.result;

    props.onContentRead(content);
  }

  function handleButtonClick() {
    fileInputRef.current.click();
  }
  return (
    <div>
      <Button onClick={() => handleButtonClick()}>
        {props.title || "Choose file"}
      </Button>
      <input
        ref={fileInputRef}
        style={{ display: "none" }}
        type="file"
        className="form-control-file"
        accept=".csv"
        onChange={(e) => {
          handleFileChosen(e.target.files[0]);
        }}
      />
    </div>
  );
}
